<mat-card>
  <mat-card-header>
    <mat-card-title class="mat-card-title-custom">
      {{'title.export_data_customer' | translate}}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="mb-3 mat-card-content-contract-sm">
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{'title.info_export_data' | translate}} {{exportTime | date:'dd/MM/yyyy HH:mm:ss'}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form #f="ngForm">
          <div class="row">
            <div class="col-lg-12 d-flex justify-content-center">
              <mat-form-field class="w-100">
                <mat-label>{{'search_form.customer_group' | translate}}</mat-label>
                <mat-select #groupCustomerSelect (focusout)="(checkFocus = true)"
                            (selectionChange)="checkFocus = false;"
                            (focus)="commonService.openComboBox(checkFocus, groupCustomerSelect)"
                            id="groupCustomerId" name="groupCustomerId" [(ngModel)]="dataSelected"
                            [multiple]="true">
                  <mat-option>
                    <ngx-mat-select-search
                      [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                      [placeholderLabel]="'search_form.search' | translate"
                      [formControl]="groupCustomerFilterCtrl">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option #allSelectedGroupCustomer
                              (click)="clickOptionGroupCustomerAll()" [value]="'isExportAll'">
                    {{ 'form.choose_all' | translate }}
                  </mat-option>
                  <mat-option #allSelectedTest
                              (click)="clickOptionTest()" [value]="'isExportNonGroup'">
                    {{ 'messages.customer_not_group' | translate }}
                  </mat-option>
                  <mat-option *ngFor="let groupCustomer of groupCustomers" [value]="groupCustomer.id"
                              (click)="clickOptionGroupCustomer(groupCustomer)">
                    {{ groupCustomer.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="row d-flex justify-content-center mb-3">
            <div class="d-flex justify-content-center mr-4">
              <div class="w-100 center-vertical">
                <button mat-stroked-button color="primary" (click)="exportData(true)" appTrackEvent="w.btn.xuat_dl_kh.xuat_day_du">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M16.3618 2.95526L13.8982 5.41889C13.852 5.46347 13.8152 5.5168 13.7898 5.57576C13.7645 5.63472 13.7512 5.69814 13.7506 5.76231C13.7501 5.82648 13.7623 5.89012 13.7866 5.94952C13.8109 6.00891 13.8468 6.06287 13.8922 6.10825C13.9375 6.15362 13.9915 6.18951 14.0509 6.21381C14.1103 6.23811 14.1739 6.25034 14.2381 6.24978C14.3023 6.24922 14.3657 6.23589 14.4246 6.21056C14.4836 6.18523 14.5369 6.14841 14.5815 6.10226L17.0452 3.63862L18.1533 4.7468C18.1835 4.77701 18.2245 4.79399 18.2672 4.794C18.2857 4.79404 18.304 4.79082 18.3213 4.7845C18.3502 4.77439 18.3756 4.75628 18.3945 4.73229C18.4135 4.7083 18.4252 4.67942 18.4283 4.64901L18.7505 1.42711C18.7529 1.40335 18.75 1.37937 18.7419 1.35688C18.7339 1.3344 18.721 1.31398 18.7041 1.2971C18.6871 1.28036 18.6667 1.26753 18.6442 1.25951C18.6218 1.2515 18.5978 1.24849 18.5741 1.25071L15.3522 1.5729C15.3219 1.576 15.2932 1.58761 15.2692 1.60638C15.2453 1.62516 15.2271 1.65033 15.2169 1.67898C15.2067 1.70763 15.2048 1.7386 15.2114 1.76829C15.218 1.79798 15.233 1.82519 15.2544 1.84676L16.3618 2.95526Z"
                      fill="#EE0033" />
                    <path
                      d="M17.9998 16.8751L17.9998 16.8765C18.0014 17.0245 17.9734 17.1713 17.9175 17.3084C17.8616 17.4454 17.7789 17.5699 17.6743 17.6746C17.5696 17.7793 17.4451 17.862 17.308 17.9179C17.171 17.9738 17.0241 18.0017 16.8761 18.0001H16.8748L3.12477 18.0001L3.1234 18.0001C2.9754 18.0017 2.82856 17.9738 2.6915 17.9179C2.55444 17.862 2.42993 17.7793 2.32527 17.6746C2.2206 17.5699 2.1379 17.4454 2.082 17.3084C2.0261 17.1713 1.99815 17.0245 1.99976 16.8765H1.99977V16.8751V3.12511H1.99978L1.99976 3.12374C1.99815 2.97573 2.0261 2.82889 2.082 2.69183C2.1379 2.55478 2.2206 2.43026 2.32527 2.3256C2.42993 2.22094 2.55444 2.13823 2.6915 2.08234C2.82856 2.02644 2.9754 1.99848 3.1234 2.0001L3.1234 2.00011H3.12477H9.06227C9.1783 2.00011 9.28958 1.95401 9.37163 1.87196C9.45368 1.78992 9.49977 1.67864 9.49977 1.56261C9.49977 1.44657 9.45368 1.33529 9.37163 1.25325C9.28958 1.1712 9.1783 1.12511 9.06227 1.12511H3.12543C2.86206 1.12239 2.60079 1.17223 2.35691 1.27173C2.11283 1.37131 1.89109 1.51862 1.70468 1.70502C1.51828 1.89142 1.37097 2.11317 1.27139 2.35725C1.1719 2.60112 1.12205 2.86239 1.12477 3.12576V16.8745C1.12205 17.1378 1.1719 17.3991 1.27139 17.643C1.37097 17.887 1.51828 18.1088 1.70468 18.2952C1.89109 18.4816 2.11283 18.6289 2.35691 18.7285C2.60077 18.828 2.86202 18.8778 3.12538 18.8751H16.8742C17.1375 18.8778 17.3988 18.828 17.6426 18.7285C17.8867 18.6289 18.1085 18.4816 18.2949 18.2952C18.4813 18.1088 18.6286 17.887 18.7281 17.643C18.8276 17.3991 18.8775 17.1379 18.8748 16.8745V10.9376C18.8748 10.8216 18.8287 10.7103 18.7466 10.6282C18.6646 10.5462 18.5533 10.5001 18.4373 10.5001C18.3212 10.5001 18.21 10.5462 18.1279 10.6282C18.0459 10.7103 17.9998 10.8216 17.9998 10.9376L17.9998 16.8751Z"
                      fill="#EE0033" stroke="#EE0033" stroke-width="0.25" />
                    <path
                      d="M11.25 10C11.9404 10 12.5 9.44036 12.5 8.75C12.5 8.05964 11.9404 7.5 11.25 7.5C10.5596 7.5 10 8.05964 10 8.75C10 9.44036 10.5596 10 11.25 10Z"
                      stroke="#EE0033" stroke-width="0.833333" stroke-miterlimit="10"
                      stroke-linecap="square" />
                    <path
                      d="M11.2499 14.1669H14.1666C14.1666 13.6339 14.0206 13.1111 13.7444 12.6553C13.4683 12.1995 13.0725 11.8281 12.6001 11.5814C12.1277 11.3346 11.5968 11.2221 11.0649 11.2559C10.533 11.2897 10.0206 11.4686 9.58322 11.7731"
                      stroke="#EE0033" stroke-width="0.833333" stroke-miterlimit="10"
                      stroke-linecap="square" />
                    <path
                      d="M6.25 11.666C6.94036 11.666 7.5 11.1064 7.5 10.416C7.5 9.72566 6.94036 9.16602 6.25 9.16602C5.55964 9.16602 5 9.72566 5 10.416C5 11.1064 5.55964 11.666 6.25 11.666Z"
                      stroke="#EE0033" stroke-width="0.833333" stroke-miterlimit="10"
                      stroke-linecap="square" />
                    <path
                      d="M6.24989 12.916C5.47634 12.916 4.73447 13.2233 4.18749 13.7703C3.64051 14.3173 3.33322 15.0591 3.33322 15.8327H9.16656C9.16656 15.0591 8.85926 14.3173 8.31228 13.7703C7.7653 13.2233 7.02344 12.916 6.24989 12.916Z"
                      stroke="#EE0033" stroke-width="0.833333" stroke-miterlimit="10"
                      stroke-linecap="square" />
                  </svg>

                  <span class="ml-2"
                        style="line-height: 33px;">{{'enterprise_contract.buttons.export_data_customer_full'
                    | translate}}</span>
                </button>
              </div>
            </div>
            <div class="d-flex justify-content-center">
              <div class="w-100 center-vertical">
                <button mat-stroked-button color="primary" (click)="exportData(false)" appTrackEvent="w.btn.xuat_dl_kh.xuat_ru_gon">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1188_17943)">
                      <path
                        d="M14.3706 4.37638L9.85387 8.89315C9.76925 8.97489 9.70175 9.07266 9.65531 9.18076C9.60887 9.28886 9.58443 9.40513 9.58341 9.52278C9.58239 9.64043 9.6048 9.7571 9.64935 9.86599C9.69391 9.97488 9.7597 10.0738 9.84289 10.157C9.92608 10.2402 10.025 10.306 10.1339 10.3505C10.2428 10.3951 10.3595 10.4175 10.4771 10.4165C10.5948 10.4155 10.711 10.391 10.8191 10.3446C10.9272 10.2982 11.025 10.2307 11.1067 10.146L15.6235 5.62925L17.6552 7.66096C17.7106 7.71635 17.7857 7.74748 17.864 7.7475C17.8979 7.74756 17.9315 7.74167 17.9633 7.73007C18.0162 7.71154 18.0627 7.67834 18.0974 7.63436C18.1321 7.59038 18.1536 7.53742 18.1594 7.48168L18.7501 1.5747C18.7544 1.53115 18.7491 1.48718 18.7344 1.44596C18.7197 1.40474 18.696 1.3673 18.665 1.33636C18.6339 1.30566 18.5964 1.28213 18.5553 1.26744C18.5141 1.25275 18.4702 1.24724 18.4267 1.25129L12.5197 1.84199C12.4642 1.84768 12.4115 1.86897 12.3676 1.90339C12.3237 1.93781 12.2904 1.98395 12.2717 2.03649C12.2529 2.08902 12.2494 2.14579 12.2616 2.20022C12.2737 2.25466 12.3011 2.30454 12.3404 2.34409L14.3706 4.37638Z"
                        fill="#EE0033" />
                      <path
                        d="M17.9687 16.8751L17.9687 16.8768C17.9703 17.0207 17.9431 17.1634 17.8888 17.2966C17.8344 17.4298 17.7541 17.5508 17.6523 17.6525C17.5506 17.7542 17.4296 17.8346 17.2964 17.8889C17.1632 17.9433 17.0205 17.9704 16.8766 17.9689H16.8749L3.12492 17.9688L3.12322 17.9689C2.97937 17.9704 2.83666 17.9433 2.70345 17.8889C2.57025 17.8346 2.44924 17.7542 2.34751 17.6525C2.24579 17.5508 2.16541 17.4298 2.11109 17.2966L1.96641 17.3556L2.11109 17.2966C2.05676 17.1634 2.02959 17.0207 2.03116 16.8768H2.03117V16.8751V3.12511H2.03118L2.03116 3.1234C2.02959 2.97955 2.05676 2.83684 2.11109 2.70364C2.16541 2.57043 2.24579 2.44942 2.34751 2.3477C2.44924 2.24598 2.57025 2.1656 2.70345 2.11127C2.83666 2.05695 2.97937 2.02977 3.12322 2.03135L3.12322 2.03136H3.12492H9.06242C9.18674 2.03136 9.30597 1.98197 9.39388 1.89406C9.48179 1.80615 9.53117 1.68693 9.53117 1.56261C9.53117 1.43829 9.48179 1.31906 9.39388 1.23115C9.30597 1.14324 9.18674 1.09386 9.06242 1.09386H3.12574C2.85827 1.09112 2.59293 1.14175 2.34526 1.24279C2.09733 1.34394 1.87208 1.49358 1.68274 1.68292C1.4934 1.87227 1.34376 2.09751 1.24261 2.34545C1.14156 2.59312 1.09093 2.85845 1.09367 3.12592V16.8743C1.09093 17.1418 1.14156 17.4071 1.24261 17.6548C1.34376 17.9027 1.49339 18.1279 1.68274 18.3173C1.87208 18.5066 2.09733 18.6563 2.34526 18.7574C2.59291 18.8585 2.85823 18.9091 3.12568 18.9064H16.8742C17.1416 18.9091 17.4069 18.8585 17.6546 18.7574C17.9025 18.6563 18.1278 18.5066 18.3171 18.3173C18.5065 18.1279 18.6561 17.9027 18.7572 17.6548C18.8583 17.4071 18.9089 17.1418 18.9062 16.8744V10.9376C18.9062 10.8133 18.8568 10.6941 18.7689 10.6061C18.681 10.5182 18.5617 10.4689 18.4374 10.4689C18.3131 10.4689 18.1939 10.5182 18.106 10.6061C18.0181 10.6941 17.9687 10.8133 17.9687 10.9376L17.9687 16.8751Z"
                        fill="#EE0033" stroke="#EE0033" stroke-width="0.3125" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1188_17943">
                        <rect width="20" height="20" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>

                  <span class="ml-2"
                        style="line-height: 33px;">{{'enterprise_contract.buttons.export_data_customer_compact'
                    | translate}}</span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </mat-expansion-panel>
    </mat-accordion>

    <!-- Danh sách lịch sử export -->
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-panel-title class="mat-panel-title mb-2 mt-3 d-flex justify-content-between align-items-center">
          <span>{{'history_report.history_export_data' | translate}}</span>
        </mat-panel-title>
        <div class="mat-table-container">
          <mat-table [dataSource]="dataSource.data" matSort width="100%" (matSortChange)="onChangeSort($event)">

            <ng-container matColumnDef="id">
              <mat-header-cell *matHeaderCellDef
                               class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                {{'enterprise_customer_management.table_headers.No' | translate}}</mat-header-cell>
              <mat-cell *matCellDef="let element"
                        class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                {{element.index + 1}}</mat-cell>
            </ng-container>


            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef style="max-width: 30%;"
                               class="mat-cell-non-boder-right-bottom">
                {{'history_report.detail_table_customer.report_name' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{element.name}}" matTooltipPosition="below"
                        style="max-width: 30%;" class="mat-cell-non-boder-right-bottom">
                <span class="fix-width">{{element.name}}</span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="type">
              <mat-header-cell *matHeaderCellDef style="max-width: 15%;"
                               class="mat-cell-non-boder-right-bottom">
                {{'history_report.detail_table_customer.type' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{element.type}}" matTooltipPosition="below"
                        style="max-width: 15%;" class="mat-cell-non-boder-right-bottom">
                <span class="fix-width">{{element.type}}</span>
              </mat-cell>
            </ng-container>


            <ng-container matColumnDef="createdTime">
              <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 25%;"
                               class="mat-cell-non-boder-right-bottom">
                {{'history_report.detail_table_customer.export_date' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" style="max-width: 25%;"
                        class="mat-cell-non-boder-right-bottom"
                        matTooltip="{{element.createdTime | date:'dd/MM/yyyy HH:mm:ss'}}">
                                <span class="fix-width text-center">{{element.createdTime | date:'dd/MM/yyyy HH:mm:ss'}}
                                </span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef style="max-width: 20%;"
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{"history_report.detail_table_customer.export_result" | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" style="max-width: 20%;"
                        class="mat-cell-non-boder-right-bottom mat-header-cell-center"
                        [matTooltip]="(element.status == 1 ? 'history_report.status.process' : element.status == 2 ? 'history_report.status.done' : 'history_report.status.error') | translate">
                                <span style="padding: 3px; width: 65%; text-align: center;"
                                      [ngStyle]="renderStatusColor(element.status)">{{element.status == 1 ? 'history_report.status.process' :
                                  element.status == 2 ? 'history_report.status.done' : 'history_report.status.error' | translate}}
                                </span>
              </mat-cell>
            </ng-container>


            <ng-container matColumnDef="action" class="mat-column-symbol">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-bottom"
                               style="max-width: 140px;">
                {{'headertable.action' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-bottom"
                        style="max-width: 140px;">

                <!-- Xem chi tiết -->
                <button mat-icon-button (click)="viewDataExport(element.id)"
                        *ngIf="element.status === 3 || element.status === 2">
                  <mat-icon matTooltip="{{'enterprise_contract.tooltips.export_customer_view' | translate}}">
                    visibility
                  </mat-icon>
                </button>
                <!-- file rỗng -->
                <button mat-icon-button *ngIf="element.status === 2 && element.isEmptyReport">
                  <i class="fa fa-file-o" aria-hidden="true"
                     matTooltip="{{'enterprise_contract.tooltips.export_customer_empty_file' | translate}}"></i>
                </button>

                <!-- tai lai -->
                <button mat-icon-button *ngIf="element.status === 3" (click)="reExportData(element.id)">
                  <mat-icon matTooltip="{{'enterprise_contract.buttons.re_export' | translate}}">
                    replay
                  </mat-icon>
                </button>

                <!-- Tải xuống -->
                <button mat-icon-button type="button"
                        (click)="downloadDataExport(element.id, element.name)"
                        *ngIf="element.status === 2 && !element.isEmptyReport">
                  <mat-icon
                    matTooltip="{{'enterprise_contract.buttons.download_export' | translate}}">
                    save_alt
                  </mat-icon>
                </button>

                <!-- Xóa -->
                <button mat-icon-button (click)="deleteDataExport(element.id, element.name)"
                        *ngIf="element.status === 2">
                  <i class="fa fa-trash" aria-hidden="true"
                     matTooltip="{{'enterprise_customer_management.buttons.delete' | translate}}"></i>
                </button>

                <!-- warning -->
                <button mat-icon-button *ngIf="element.status === 3">
                  <i class="fa fa-warning text-danger" aria-hidden="true"
                     matTooltip="{{element.errorMessage}}"></i>
                </button>

              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
          </mat-table>
        </div>
        <!-- Pagination -->
        <app-pagination [(paginate)]="paginate"
                        (pageChange)="getAllExportHistory($event.page, $event.pageSize)">
        </app-pagination>
        <!-- /Pagination -->
      </mat-expansion-panel>
    </mat-accordion>
  </mat-card-content>
</mat-card>
